import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10v3a1 1 0 0 0 1 1h9m4 0h1a1 1 0 0 0 1 -1v-3","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconSpaceOff = createReactComponent('outline', 'space-off', 'SpaceOff', __iconNode);

export default IconSpaceOff;